module.exports = __webpack_public_path__ + "static/media/chat-46.6cb414a7.svg";